export const resizeParent = () => {
    setTimeout(() => {
        postMessage('RESIZE_PARENT', {
            height: document.documentElement.offsetHeight,
            origin: window.location.href
        })
    }, 250)

}

export const postMessage = (action, data) => {

    if (!window.parent) return;

    const customData = { action, data };
    window.parent.postMessage(JSON.parse(JSON.stringify(customData)), '*')
}

export const setCookie = (c_name, value, exdays) => {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + exdays);
    var c_value = escape(value) + ((exdays == null) ? "" : "; expires=" + exdate.toUTCString());
    document.cookie = c_name + "=" + c_value + "; path=/";
}

export const getCookie = (c_name) => {
    var i, x, y, ARRcookies = document.cookie.split(";");
    for (i = 0; i < ARRcookies.length; i++) {
        x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
        y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
        x = x.replace(/^\s+|\s+$/g, "");
        if (x == c_name) {
            return unescape(y);
        }
    }
}

export const loadStylesheet = (cssId, href) => {
    if (!document.getElementById(cssId)) {
        var head = document.getElementsByTagName('head')[0];
        var link = document.createElement('link');
        link.id = cssId;
        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.href = href;
        link.media = 'all';
        head.appendChild(link);
    }
}

export const isInMobileApp = () => {
    const body = document.querySelector('.inappview');
    if (body) return true;
    return false;
}

export const handleNewTabLink = (e, target, url) => {
    const inApp = isInMobileApp();
    if (inApp) {
        // Load in current frame
        window.parent.location.href = url;
    } else if (target === '_blank') {
        e.preventDefault();
        window.open(url);
        return;
    }
}

export const trackEvent = (eventName, args = {}) => {
    var comb = {
        'send_to': 'globaltracking',
        ...args
    }
    if (typeof gtag === 'undefined') return;
    gtag('event', eventName, comb);
}